export default {
  'ARCHIVE' (state) {
    return state.archive
  },
  'ARCHIVES' (state) {
    return state.archives
  }
}
